import { TaskVariable } from '../../interfaces/variable-services/task-variable';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a SetVariable task — stores one or more values into named
 * variables scoped either per-record (contextData) or flow-wide (flowVariables).
 * Expression strings in variable.value are auto-detected and evaluated at runtime.
 */
export class SetVariableConfig extends DestinationTaskConfigBase {
	/**
	 * Array of variable definitions to set. Each entry specifies the name, value,
	 * and scope (RecordVariable=0 → contextData, FlowVariable=1 → flowVariables).
	 * @default []
	 */
	variables: TaskVariable[] = [];

	constructor(init?: Partial<SetVariableConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
